// extracted by mini-css-extract-plugin
export default {"dlCollapseButton":"src-js-components-CollapseButton---dlCollapseButton---tG6Ss"};